import React, { useState } from "react";
import "./Articulos.css";

const articulos = [
  {
    id: 1,
    titulo: "tBTC3: The Bitcoin That Never Died",
    fecha: "2025-06-30",
    imagen: "/images/imgarart1.webp", // ✅ Pon la ruta real de tu imagen
   contenido: (
      <>
        <blockquote>
          <em>
            They tried to shut it down.<br />
            They tried to move on.<br />
            But the chain kept ticking.<br />
            Block after block.<br />
            tBTC3 never died.
          </em>
        </blockquote>

        <h2>🧬 What Is tBTC3?</h2>
        <p>
          tBTC3 is the third iteration of Bitcoin's testnet — originally intended as a temporary testing environment. It was supposed to be replaced by testnet4. It was supposed to fade into the archives of code. But it didn't.
        </p>
        <p>
          The network resisted. Nodes kept running. Blocks kept being mined. Transactions never stopped. Today, testnet3 still breathes.
        </p>
        <p>
          And now, a community is reviving it — not just as a testnet, but as a <strong>symbol of resilience, decentralization, and experimental sovereignty.</strong>
        </p>

        <h2>🧠 Why It Matters</h2>
        <p>
          In a world increasingly dependent on centralized test environments, tBTC3 stands as a ghost chain that refused to die. It's a fully functioning blockchain with:
        </p>
        <ul>
          <li>Real proof-of-work.</li>
          <li>Transparent public ledger.</li>
          <li>Active mining.</li>
          <li>Swap  (e.g., Sepolia → tBTC3).</li>
          <li>Real experimentation.</li>
        </ul>
        <p>
          If it has scarcity, computation, transactions, history and users...<br />
          Then it has something that resembles value.
        </p>

        <h2>⚔️ The Attempt to Kill It</h2>
        <p>
          Bitcoin core  Developers deprecated testnet3. They introduced testnet4 with faster resets. They shut down many faucets and nodes.
        </p>
        <p>But some refused.</p>
        <ul>
          <li>Miners continued solving blocks.</li>
          <li>Enthusiasts built bridges and services.</li>
          <li>Some started trading it, even if just symbolically.</li>
        </ul>
        <p>
          The network became like an underground stream — flowing beneath the surface of official narratives.
        </p>

        <h2>🌱 A New Purpose</h2>
        <p>
          We're not saying tBTC3 should replace mainnet.<br />
          We're saying <strong>it deserves recognition</strong> as:
        </p>
        <ul>
          <li>A decentralized environment for <em>true</em> testing.</li>
          <li>A symbolic chain for educational and economic simulations.</li>
          <li>A place for bridging Ethereum testnets and Bitcoin logic.</li>
          <li>A canvas for experiments, not controlled by core resets.</li>
        </ul>

        <h2>🔗 Use Cases Emerging</h2>
        <ul>
          <li>adquire tbtc  swap Sepolia to  tBTC3 </li>
          <li>Faucet-free experimentation: you can mine your own BTC again.</li>
          
          <li>Network sovereignty: run your own node, keep history alive.</li>
        </ul>

        <h2>🚩 Join the Resistance</h2>
        <p>
          If you believe in decentralization, in experimental freedom,<br />
          in systems that refuse to die — then tBTC3 is for you.
        </p>
        <ul>
          <li>Set up a node.</li>
          <li>Test your contracts.</li>
          <li>Create tools.</li>
          <li>Mint symbolic tokens.</li>
          <li>Be a Guardian of the chain that lived.</li>
        </ul>
        <blockquote>
          <strong>Long live tBTC3. The Bitcoin that never died.</strong>
        </blockquote>
        <hr />
        <p>
          🔗 Learn more:<br />
          🌐 <a href="you can swap  here" target="_blank" rel="noopener noreferrer">Bridge App (Sepolia to tBTC3)</a><br />
          📡 <a href="https://tbtc.bitaps.com" target="_blank" rel="noopener noreferrer">Explorer</a><br />
          💬 Community (Telegram/Discord soon)
        </p>
      </>
    ),
  },
  {
    id: 2,
    titulo: "tBTC3 as a New Digital Frontier: Scarcity, Value, and Symbolic Resistance",
    fecha: "2025-07-02",
    imagen: "/images/imgart2.webp", // ✅ Pon la ruta real de tu imagen
    contenido: (
      <>
   
        
  <h2>tBTC3 is Not Just a Testnet Anymore</h2>
  <p>The world treats testnet coins as “valueless.” But tBTC3 broke that narrative. It survived resets, developer abandonment, and faucet droughts. It now has historical continuity, economic dynamics, and symbolic resistance.</p>

  <h2>🔍 Scarcity Is Emerging</h2>
  <p>Faucets are nearly extinct. Mining is back. People are trading tBTC3 for Sepolia ETH. This is not a sandbox anymore — it’s a controlled Bitcoin simulation with real scarcity.</p>

  <h2>💡 Symbolic vs. Real Value</h2>
  <p>No fiat price. But symbolic value — independence, resilience, and digital resistance. Over time, that becomes real.</p>

  <h2>🧠 Philosophical Implications</h2>
  <p>Testnet3 raises deep questions: What if abandoned networks return? What if we build on ghost chains? It challenges centralized assumptions of value and resets.</p>

  <h2>⚙️ Real Use Cases Already Live</h2>
  <ul>
    <li>Swapping Sepolia ETH ↔ tBTC3</li>
    <li>Mining simulations</li>
    <li>Micro economies in a discarded chain</li>
    <li>Bridges, wallets, NFTs</li>
  </ul>

  <h2>🌐 Toward a Sovereign Digital Micro-Economy</h2>
  <p>tBTC3 could become a sovereign experimental network. A rare cultural artifact. Mined and used for learning — not greed.</p>

  <h2>🔥 Conclusion: The Rise of Experimental Sovereignty</h2>
  <p>tBTC3 refused to die. Now it lives more freely than ever — not under control, but alive. This is the symbol of a new frontier in open experimentation.</p>

  <blockquote className="border-l-4 pl-4 italic">
    Run a node. Mine a block. Build a bridge. Become part of the chain they abandoned — and we revived.
  </blockquote>
      </>
    ),
  },
   {
    id: 3,
    titulo: "Testnet3: The Forgotten Blockchain That Refused to Die",
    fecha: "2025-07-14",
    imagen: "/images/imgart3.webp", // ✅ Pon la ruta real de tu imagen
    contenido: ( <>  <header>
 
    <p class="badge">🧱 A Chain That Survived Abandonment</p>
    <p>In the ever-changing landscape of Bitcoin development, networks come and go. Testnet1 and Testnet2 faded into history. Testnet3 was expected to follow—but it didn’t.</p>
  </header>

  <section>
    <h2>💥 From Testing Ground to Sovereign Network</h2>
    <p>Originally launched by Bitcoin Core developers as a sandbox for innovation, Testnet3 was a duplicate of Bitcoin with no monetary value. But over time, something unusual happened:</p>
    <ul>
      <li>Blocks kept being mined.</li>
      <li>Transactions never stopped.</li>
      <li>Developers continued building wallets, services, and even exchanges.</li>
    </ul>
    <p>A new form of economic activity emerged—organic, decentralized, and unstoppable.</p>
    <p><strong>Testnet3, abandoned, refused to die.</strong></p>
  </section>

  <section>
    <h2>🔗 Why Testnet3 Might Matter</h2>
    <ul>
      <li><strong>✔️ Proof of Survival:</strong> Over a decade of uninterrupted block production.</li>
      <li><strong>✔️ Decentralization by Accident:</strong> No central authority controls it now.</li>
      <li><strong>✔️ Community Mining:</strong> With low difficulty, miners participate voluntarily.</li>
      <li><strong>✔️ Emergent Scarcity:</strong> As more users build services, tBTC3 becomes less accessible.</li>
    </ul>
    <p>This network is no longer just a clone. It’s becoming a living organism with its own culture, economy, and value.</p>
  </section>

  <section>
    <h2>🌍 A Call to Builders, Not Speculators</h2>
    <p>Testnet3 isn’t about profit. It’s about freedom, experimentation, and ownership of infrastructure. We don’t need permission to make it thrive.</p>
    <p>If Bitcoin is digital gold, Testnet3 is digital clay—malleable, abundant, and ready for those who want to build the next layer of decentralized tools, bridges, and marketplaces.</p>
  </section>

  <section>
    <h2>⚡ Join the Movement</h2>
    <p>We’re launching services that allow swapping assets between Sepolia and Testnet3, creating a new ecosystem of cross-chain innovation. This is just the beginning.</p>
    <blockquote>
      “Don’t wait for permission. Don’t wait for ‘value’. Build because it matters.”
    </blockquote>
    <a href="https://www.bitdragex.com/" class="swap-link">⭐ Go to Sepolia ↔ Testnet3 Swap Service</a>
  </section>


 </>),},
];

function Articulos() {
  const [articuloSeleccionado, setArticuloSeleccionado] = useState(null);

  return (
    <div className="articulo-container">
      <h1 style={{ marginBottom: "1em" }}>ARTICLES</h1>

      {!articuloSeleccionado ? (
        <ul className="articulos-lista">
          {articulos.map((art) => (
            <li key={art.id} style={{ listStyle: "none" }}>
              <div
                className="articulo-card"
                onClick={() => setArticuloSeleccionado(art)}
                tabIndex={0}
                role="button"
              >
                <img
                  src={art.imagen}
                  alt={art.titulo}
                  className="articulo-imagen"
                />
                <strong>{art.titulo}</strong>
                <div style={{ fontSize: "0.95em", opacity: 0.8 }}>
                  {art.fecha}
                </div>
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <div className="articulo-detalle">
          <button
            onClick={() => setArticuloSeleccionado(null)}
            className="volver-boton"
          >
            ← Return
          </button>
          <h1>{articuloSeleccionado.titulo}</h1>
          <img
            src={articuloSeleccionado.imagen}
            alt={articuloSeleccionado.titulo}
            className="articulo-imagen-detalle"
          />
          <div>{articuloSeleccionado.contenido}</div>
        </div>
      )}
    </div>
  );
}

export default Articulos;
